import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export type SammelPickOption = {
    label: string;
    id?: number;
};

export type DashboardSammelstelleOptionPickData = {
    title: string;
    options: SammelPickOption[];
    selected: string | null | string[];
    multi?: boolean;
    /** Optional free-text create field label. */
    createLabel?: string;
};

export type DashboardSammelstelleOptionPickResult = {
    labels: string[];
    created?: string;
};

@Component({
    selector: 'kiene-dashboard-sammelstelle-option-pick-dialog',
    templateUrl: './dashboard-sammelstelle-option-pick-dialog.component.html',
    styleUrls: ['./dashboard-sammelstelle-option-pick-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DashboardSammelstelleOptionPickDialogComponent implements OnInit {
    search = '';
    createText = '';
    multiDraft: string[] = [];

    constructor(
        private readonly dialogRef: MatDialogRef<
            DashboardSammelstelleOptionPickDialogComponent,
            DashboardSammelstelleOptionPickResult | null
        >,
        @Inject(MAT_DIALOG_DATA) public data: DashboardSammelstelleOptionPickData,
    ) {}

    ngOnInit(): void {
        if (this.data.multi) {
            this.multiDraft = Array.isArray(this.data.selected) ? [...this.data.selected] : [];
        }
    }

    get filtered(): SammelPickOption[] {
        const q = this.search.trim().toLowerCase();
        const opts = this.data.options ?? [];
        if (!q) return opts;
        return opts.filter(o => o.label.toLowerCase().includes(q));
    }

    isSelected(label: string): boolean {
        if (this.data.multi) {
            return this.multiDraft.includes(label);
        }
        return this.data.selected === label;
    }

    pick(label: string): void {
        if (this.data.multi) {
            if (this.multiDraft.includes(label)) {
                this.multiDraft = this.multiDraft.filter(x => x !== label);
            } else {
                this.multiDraft = [...this.multiDraft, label];
            }
            return;
        }
        this.dialogRef.close({ labels: [label] });
    }

    confirmMulti(): void {
        this.dialogRef.close({ labels: [...this.multiDraft] });
    }

    create(): void {
        const text = this.createText.trim();
        if (!text) return;
        if (this.data.multi) {
            const next = this.multiDraft.includes(text) ? this.multiDraft : [...this.multiDraft, text];
            this.dialogRef.close({ labels: next, created: text });
            return;
        }
        this.dialogRef.close({ labels: [text], created: text });
    }

    close(): void {
        this.dialogRef.close(null);
    }
}
